import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, Container } from '@bpba/ui-components';
import { MdOutlinePhoneAndroid } from 'react-icons/md';
import { ReactComponent as WhatsAppLogo } from '../assets/whatsapp.svg';
import { LayoutWrapper } from './LayoutWrapper';
import { PageWrapper } from './PageWrapper';

const sessionInfo = (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '16px', fontSize: '14px', whiteSpace: 'nowrap' }}>
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      <MdOutlinePhoneAndroid size={16} />
      0810-222-2776
    </span>
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      <WhatsAppLogo aria-label="WhatsApp" role="img" style={{ width: 16, height: 16, display: 'block' }} />
      11-2821-6222
    </span>
  </span>
);

export const Layout = ({ children }: { children?: ReactNode }) => (
  <LayoutWrapper>
    <AppBar title="Buscador de sucursales y cajeros" sessionInfo={sessionInfo as unknown as string} />
    <Container flexDirection="column" alignItems="stretch">
      <PageWrapper>{children ?? <Outlet />}</PageWrapper>
    </Container>
  </LayoutWrapper>
);
